import { QueryClient } from "@tanstack/react-query"
import { AxiosError } from "axios"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error: unknown) => {
        const isAxios = error instanceof AxiosError
        const is4xx =
          isAxios &&
          error.response !== undefined &&
          error.response.status >= 400 &&
          error.response.status < 500
        return is4xx ? false : count < 3
      },
    },
  },
})
